__turbopack_context__.v({
  "root": "rXXTea_root",
});
